import { merge, of } from 'rxjs';
import {
	filter, mergeMap, switchMap, takeUntil,
} from 'rxjs/operators';

import { Container, Service } from '../../../../symphony';

import { SlActions } from './sl-actions';
import {
	aISolutionsUnsubscriber$,
	SlAISolutionsContext,
} from '../../global-constants';
import { SlActionsController } from './sl-actions.controller';
import { IAction, ActionType, RequestType } from '../../global-interface';

@Service()
export class SlActionsSolutionsService {
	private aISolutionsActions$ = Container.take(
		SlAISolutionsContext,
		SlActions,
	).actions$;

	private controller = Container.take(
		SlAISolutionsContext,
		SlActionsController,
	);

	private cancelableActionsMap = {};

	private parallelActionsMap = {
		// UI events
		[ActionType.OnAISolutionsMount]:
			this.controller.aISolutionsMountHandler,
		[ActionType.OnAISolutionsDataUpdate]:
			this.controller.aISolutionsDataUpdateHandler,
		[ActionType.OnAISolutionClick]: this.controller.aISolutionClickHandler,
		[ActionType.OnAISolutionRate]: this.controller.aISolutionRateHandler,
		[ActionType.OnAISolutionCollapse]:
			this.controller.aISolutionCollapseHandler,
		[ActionType.OnAISolutionsClose]:
			this.controller.aISolutionsCloseHandler,
		[ActionType.OnAISolutionsOpen]: this.controller.aISolutionsOpenHandler,
		[ActionType.OnGetAIResponseInBottomSheetClick]:
			this.controller.getAIResponseInBottomSheetClickHandler,
		[ActionType.OnAISolutionResponseCopy]:
			this.controller.aISolutionResponseCopyHandler,

		// Business events
	};

	constructor() {
		const cancelable = this.aISolutionsActions$.pipe(
			filter((a) => !!a && a.requestType === RequestType.Cancelable),
			switchMap((action: IAction) => {
				const handler = this.cancelableActionsMap[action.type];
				return handler ? handler(action.data) : of(action);
			}),
		);

		const parallel = this.aISolutionsActions$.pipe(
			filter((a) => !!a && a.requestType === RequestType.Parallel),
			mergeMap((action: IAction) => {
				const handler = this.parallelActionsMap[action.type];
				return handler ? handler(action.data) : of(action);
			}),
		);

		merge(cancelable, parallel)
			.pipe(
				filter((a) => !!a),
				takeUntil(aISolutionsUnsubscriber$),
			)
			.subscribe();
	}
}
